// extracted by mini-css-extract-plugin
module.exports = {"box":"box--5XMZZ","footer":"footer--WR5NX","logo":"logo--DS1of","info":"info--yCEdx","info_foreign":"info_foreign--EKMv7"};